/**
 * Available save flows
 * @readonly
 * @enum {string}
 */
export const SaveFlows = Object.freeze({
  cart: "cart",
  email: "email",
});

/**
 * Available environments
 * @readonly
 * @enum {string}
 */
export const Environments = Object.freeze({
  preview: "preview",
  production: "admin-fts",
});

/**
 * Available API environments
 * @readonly
 * @enum {string}
 */
export const ApiEnvironments = {
  dev: "dev",
  test: "test",
  nitrogen: "nitrogen",
  oxygen: "oxygen",
  stage: "stage",
  production: "production",
};
